import { combineReducers } from 'redux';

import auditStatisticsReducer from 'reducers/auditStatisticsReducer';

import ui from './ui';

export default combineReducers({
  oldReducer: auditStatisticsReducer,
  ui,
});
